import api from "../../../../service/api";
import routes from "../../../../service/apiRoutes";


export const listServicesStatus = (data) => api.get(`${routes.listServicesStatus}`, {params: data})
export const retryService = (serviceId) => api.put(`${routes.service}retry?service_id=${serviceId}`, {})
